import { useMutation } from '@tanstack/react-query'
import { useCartContext } from '../components'

export const useRemoveCartItems = () => {
  const { cartManager } = useCartContext()
  return useMutation({ mutationFn: cartManager.removeItems })
}
